import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import axios from "../../components/axios";
import useFullPageLoader from "../../components/useFullPageLoader";
import Swal from "sweetalert2";
import { useUser } from "../../components/UserContext";

const UpdateCertificateDetails = ({ open, onClose, updateData }) => {
    const { userData } = useUser();
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [show, setShow] = useState(open);
    const [errors, setErrors] = useState({});
    
    const [customer, setCustomer] = useState({
        Renewal_Date: "",
        State:"",
        Username: "",
        Password: "",
        Updated_By: `${userData?.First_Name} ${userData?.Last_Name}`,
        Updated_By_Id: userData?.UserId,
    });
    useEffect(() => {
        if (updateData) {
            console.log("Received updateData:", updateData);
            console.log("updated data", updateData.Application_Username);
            
            setCustomer(prev => ({
                ...prev,
               Renewal_Date: updateData.Renewal_Date 
                ? updateData.Renewal_Date.split("T")[0] 
                : "",
                State: updateData.State || updateData.StateorCPCB || "",
                Username: updateData.Application_Username?.trim() || "",   
                Password: updateData.Application_Password || "",
            }));
        }
    }, [updateData]);

    const indianStates = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Delhi",
        "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
        "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
        "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
        "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
        "Uttar Pradesh", "Uttarakhand", "West Bengal", "CPCB"
      ];

      const handleInputChangeForState = (e) => {
        setCustomer({
          ...customer,
          [e.target.name]: e.target.value, // Ensure the value updates
        });
      };

    const handleClose = () => {
        setShow(false);
        onClose();
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        showLoader();
        await axios
            .put(`/updateCertificateDetails/${updateData?.Enquiry_Sr_No}`, customer)
            .then(() => {
                Swal.fire("Success!", "Details Updated Successfully!", "success").then((result) => {
                    if (result.isConfirmed) {
                        handleClose();
                    }
                });
                hideLoader();
            })
            .catch(() => {
                Swal.fire({
                    title: "Error",
                    text: "Failed to update details. Please try again later.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
                hideLoader();
            });
    };

    return (
        <Modal show={show} onHide={handleClose} size="xl" centered>
            <Modal.Body>
                <div className="row align-items-center">
                    <h5 className="col-md-6">Update Acknowledgement Details - ({updateData.Certificate_Name || ""})</h5>
                </div>
                <hr className="p-0 mb-1" />
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="mb-2">
                                <label htmlFor="Renewal_Date" className="form-label">Renewal Date<span style={{ color: "red" }}>*</span></label>
                                <input type="date" id="Renewal_Date" className="form-control" value={customer.Renewal_Date} required onChange={(e) => setCustomer({ ...customer, Renewal_Date: e.target.value })} />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2">
                                <label htmlFor="Username" className="form-label">Username<span style={{ color: "red" }}>*</span></label>
                                <input type="text" id="Username" className="form-control" placeholder="Enter Username" value={customer.Username} required onChange={(e) => setCustomer({ ...customer, Username: e.target.value })} />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2">
                                <label htmlFor="Password" className="form-label">Password<span style={{ color: "red" }}>*</span></label>
                                <input type="text" id="Password" className="form-control" placeholder="Enter Password" value={customer.Password} required onChange={(e) => setCustomer({ ...customer, Password: e.target.value })} />
                            </div>
                        </div>
                        <div className="col-md-3">
          <label className="form-label">State<span style={{ color: "red" }}>*</span></label>
          <select
            className="form-control"
            name="State"
            value={customer.State}
            onChange={handleInputChangeForState}
          >
            <option value="">Select State</option>
            {indianStates.map((state, index) => (
              <option key={index} value={state}>
                {state}
              </option>
            ))}
          </select>
        </div>
                    </div>
                    <div className="row justify-content-center mt-4">
                        <div className="col-md-2 col-sm-3 col-xs-3 col-3">
                            <button type="submit" className="btn btn-md btn-primary">Update</button>
                        </div>
                    </div>
                </form>
                {loader}
            </Modal.Body>
        </Modal>
    );
};

export default UpdateCertificateDetails;


// import React, { useState, useEffect } from "react";
// import { Modal } from "react-bootstrap";
// import axios from "../../components/axios";
// import useFullPageLoader from "../../components/useFullPageLoader";
// import Swal from "sweetalert2";
// import { useUser } from "../../components/UserContext";

// const UpdateCertificateDetails = ({ open, onClose, updateData }) => {
//     const { userData } = useUser();
//     const [loader, showLoader, hideLoader] = useFullPageLoader();
//     const [show, setShow] = useState(open);
//     const [errors, setErrors] = useState({});

//     const indianStates = [
//         "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
//         "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
//         "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
//         "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
//         "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
//         "Uttar Pradesh", "Uttarakhand", "West Bengal", "CPCB"
//     ];

//     const [customer, setCustomer] = useState({
//         Renewal_Date: "",
//         State: "",
//         Username: "",
//         Password: "",
//         Updated_By: `${userData?.First_Name} ${userData?.Last_Name}`,
//         Updated_By_Id: userData?.UserId,
//     });

//     // Populate customer state when updateData changes
//     useEffect(() => {
//         if (updateData) {
//             console.log("Received updateData:", updateData);
//             setCustomer(prev => ({
//                 ...prev,
//                Renewal_Date: updateData.Renewal_Date 
//                 ? updateData.Renewal_Date.split("T")[0] 
//                 : "",
//                 State: updateData.State || updateData.StateorCPCB || "",
//                 Username: updateData.Application_Username?.trim() || "",   
//                 Password: updateData.Application_Password || "",
//             }));
//         }
//     }, [updateData]);

//     const handleInputChangeForState = (e) => {
//         setCustomer({
//             ...customer,
//             [e.target.name]: e.target.value,
//         });
//     };

//     const handleClose = () => {
//         setShow(false);
//         onClose();
//     };

//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         showLoader();

//         await axios
//             .put(`/updateCertificateDetails/${updateData?.Enquiry_Sr_No}`, customer)
//             .then(() => {
//                 Swal.fire("Success!", "Details Updated Successfully!", "success").then((result) => {
//                     if (result.isConfirmed) {
//                         handleClose();
//                     }
//                 });
//                 hideLoader();
//             })
//             .catch(() => {
//                 Swal.fire({
//                     title: "Error",
//                     text: "Failed to update details. Please try again later.",
//                     icon: "error",
//                     confirmButtonText: "OK",
//                 });
//                 hideLoader();
//             });
//     };

//     return (
//         <Modal show={show} onHide={handleClose} size="xl" centered>
//             <Modal.Body>
//                 <div className="row align-items-center">
//                     <h5 className="col-md-6">
//                         Update Acknowledgement Details - ({updateData?.Certificate_Name || ""})
//                     </h5>
//                 </div>
//                 <hr className="p-0 mb-1" />
//                 <form onSubmit={handleSubmit}>
//                     <div className="row">
//                         <div className="col-md-3 mb-2">
//                             <label htmlFor="Renewal_Date" className="form-label">Renewal Date<span className="text-danger">*</span></label>
//                             <input type="date" id="Renewal_Date" className="form-control" value={customer.Renewal_Date} required onChange={(e) => setCustomer({ ...customer, Renewal_Date: e.target.value })} />
//                         </div>
//                         <div className="col-md-3 mb-2">
//                             <label htmlFor="Username" className="form-label">Username<span className="text-danger">*</span></label>
//                             <input type="text" id="Username" className="form-control" placeholder="Enter Username" value={customer.Username} required onChange={(e) => setCustomer({ ...customer, Username: e.target.value })} />
//                         </div>
//                         <div className="col-md-3 mb-2">
//                             <label htmlFor="Password" className="form-label">Password<span className="text-danger">*</span></label>
//                             <input type="text" id="Password" className="form-control" placeholder="Enter Password" value={customer.Password} required onChange={(e) => setCustomer({ ...customer, Password: e.target.value })} />
//                         </div>
//                         <div className="col-md-3 mb-2">
//                             <label className="form-label">State<span className="text-danger">*</span></label>
//                             <select className="form-control" name="State" value={customer.State} onChange={handleInputChangeForState}>
//                                 <option value="">Select State</option>
//                                 {indianStates.map((state, index) => (
//                                     <option key={index} value={state}>{state}</option>
//                                 ))}
//                             </select>
//                         </div>
//                     </div>
//                     <div className="row justify-content-center mt-4">
//                         <div className="col-md-2">
//                             <button type="submit" className="btn btn-primary w-100">Update</button>
//                         </div>
//                     </div>
//                 </form>
//                 {loader}
//             </Modal.Body>
//         </Modal>
//     );
// };

// export default UpdateCertificateDetails;
